import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-email',
    imports: [],
    templateUrl: './email.component.html',
    styles: ``
})
export class EmailComponent implements OnInit {
  otp = '1234';

  ngOnInit(): void {
    this.otp = Math.floor(Math.random() * 900000 + 100000).toString();
  }
}
